import { RosterGroup } from '@/model';
import {
  GetRosterGroupByIdResponse,
  GetRosterGroupItemResponse,
  GetRosterGroupResponse,
  PostRosterGroupResponse,
  PutRosterGroupResponse,
} from '@/services/response/roster-group';

export class RosterGroupConverter {
  static toDomainFromGetItemResponse(response: GetRosterGroupItemResponse): RosterGroup {
    return {
      uuid: response.uuid,
      name: response.name,
      show_stats: response.show_stats,
      position_order: response.position_order,
      sort_order: response.sort_order,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetRosterGroupResponse): RosterGroup[] {
    return response.data.map(RosterGroupConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromByIdResponse(response: GetRosterGroupByIdResponse): RosterGroup {
    return RosterGroupConverter.toDomainFromGetItemResponse(response);
  }

  static toDomainFromPostResponse(response: PostRosterGroupResponse): RosterGroup {
    return {
      uuid: response.uuid,
      name: response.name,
      show_stats: response.show_stats,
      position_order: response.position_order,
      sort_order: response.sort_order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutRosterGroupResponse): RosterGroup {
    return {
      uuid: response.uuid,
      name: response.name,
      show_stats: response.show_stats,
      position_order: response.position_order,
      sort_order: response.sort_order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
